// extracted by mini-css-extract-plugin
module.exports = {"firstHalfInput":"InvestmentForm_firstHalfInput__12HH-","secondHalfInput":"InvestmentForm_secondHalfInput__2HjUg"};